import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=238fd738&scoped=true"
import script from "./HeaderNotice.vue?vue&type=script&lang=js"
export * from "./HeaderNotice.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&id=238fd738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238fd738",
  null
  
)

export default component.exports